export default function NotFound() {
  return (
    <div className="m-auto space-y-5 text-center">
      <h1 className="text-3xl font-bold">Not Found</h1>
      <p>The site that you look for does not exist.</p>
    </div>
  );
}